import { useState, useEffect } from "react";

const useWindowDimensions = () => {
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : null // Check if window is defined
  );

  useEffect(() => {
    // Only add the event listener if we are in the browser
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      };

      // Set the initial width
      handleResize();

      // Add event listener for window resize
      window.addEventListener("resize", handleResize);

      // Clean up the event listener on unmount
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  return screenWidth;
};

export default useWindowDimensions;
